import styled from 'styled-components';
import { Tree } from '~/components';

export const TreeTransparente = styled(Tree)`
  &&.draggable-tree {
    background: transparent !important;
  }
`;
